import React from "react";
import { Formik, Field, Form } from "formik";
import { object } from "yup";
import { DatePicker } from "../../components/datetime-picker.component";
import { TextField } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import { Typography, Paper } from "@material-ui/core";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import AlertDialog from "../../components/alert.component";
import ConfirmDialog from "../../components/confirm.component";
import { Api } from "../../utils/api";
import moment from "moment";

var email_first_settence =
  "Estimado Sr(a). <entity_user_name>\\n\\n" + "Boa tarde,\\n\\n";
var email_last_settence =
  "Estamos ao inteiro dispor para qualquer assunto ou esclarecimento adicional.\\n\\n" +
  "Com os nossos melhores cumprimentos,\\n\\n" +
  "Lares Online\\n" +
  "Departamento Financeiro";
var email_body_intro =
  "Vimos por este meio e relativamente ao processo de admissão do Utente Sr(a). <elderly_name>, sendo Emissor do Pedido Sr(a). <requester_name>, admitido no(a) <establishment_name>, no passado dia <admission_date> com mensalidade de <monthly_payment>€, enviar em anexo os documentos rectificativos deste processo, realizado através da Plataforma Lares Online.\\n" +
  "De acordo com a informação enviada, este processo de admissão foi interrompido, tendo sido pago o valor referente a <total_days> dias de internamento.\\n" +
  "Desta forma foi accionada a nossa garantia de estorno, que deu origem à emissão dos seguintes documentos:\\n\\n";
//
var invoice_settled_observations =
  email_first_settence +
  email_body_intro +
  "1- Foi cancelado o recibo <receipt_seq_nr> no valor de <old_invoice_value>€\\n" +
  "2- Foi emitida a nota de crédito <credit_note_seq_nr> no valor de <old_invoice_value>€ de forma a anular a factura <old_invoice_seq_nr> do mesmo valor.\\n" +
  "3- Em substituição da fatura <old_invoice_seq_nr> foi emitida a factura-recibo <new_invoice_seq_nr> no montante de <new_invoice_value>€ \\n" +
  "4- Foi realizada a transferência de <credit_value>€ para a vossa conta bancária correspondente à diferença dos valores anteriores.\\n\\n" +
  "O valor da Factura-Recibo <new_invoice_seq_nr> foi calculado da seguinte forma:\\n\\n" +
  "- Valor de comissão inicial: <old_invoice_value>€\\n" +
  "- Garantia: <warranty_days> dias\\n" +
  "- Valor ao dia para efeito de cálculo de comissão correspondente (<old_invoice_value>€ / <warranty_days> dias) = <warranty_value_per_day> € / dia (IVA Incluído)\\n" +
  "- Valor final de comissão e referente a (<total_days> dias x <warranty_value_per_day>€ = <new_invoice_value>€) IVA Incluído\\n\\n" +
  email_last_settence;
//
var invoice_final_observations =
  email_first_settence +
  email_body_intro +
  "1- Foi emitida a nota de crédito <credit_note_seq_nr> no valor de <old_invoice_value>€, de forma a anular a factura <old_invoice_seq_nr> do mesmo valor.\\n" +
  "2- Em substituição da fatura <old_invoice_seq_nr>, foi emitida a factura <new_invoice_seq_nr> no montante de <new_invoice_value>€ \\n\\n" +
  "O valor da Factura <new_invoice_seq_nr> foi calculado da seguinte forma:\\n\\n" +
  "- Valor de comissão inicial: <old_invoice_value>€\\n" +
  "- Garantia: <warranty_days> dias\\n" +
  "- Valor ao dia para efeito de cálculo de comissão correspondente (<old_invoice_value>€ / <warranty_days> dias) = <warranty_value_per_day> € / dia (IVA Incluído)\\n" +
  "- Valor final de comissão e referente a (<total_days> dias x <warranty_value_per_day>€ = <new_invoice_value>€) IVA Incluído\\n\\n" +
  email_last_settence;
//
var invoice_settled_observations_zero_days =
  email_first_settence +
  email_body_intro +
  "1- Foi cancelado o recibo <receipt_seq_nr> no valor de <old_invoice_value>€\\n\\n" +
  "2- Foi emitida a nota de crédito <credit_note_seq_nr> no valor de <old_invoice_value>€ de forma a anular a factura <old_invoice_seq_nr> do mesmo valor.\\n\\n" +
  "3- Foi realizada a transferência de <credit_value>€ para a vossa conta bancária correspondente à diferença dos valores anteriores.\\n\\n" +
  email_last_settence;
//
var invoice_final_observations_zero_days =
  email_first_settence +
  email_body_intro +
  "1- Foi emitida a nota de crédito <credit_note_seq_nr> no valor de <old_invoice_value>€ de forma a anular a factura <old_invoice_seq_nr> do mesmo valor.\\n\\n" +
  email_last_settence;
//
var _documentsToBeCreated_invoice =
  "Serão criados os seguintes documentos:\\n - Nota de Crédito sobre a fatura corrente no valor de <old_invoice_value>€;\\n - Fatura com o montante remanescente, no valor de <new_invoice_value>€;";
//
var _documentsToBeCreated_invoice_zero =
  "Serão criados os seguintes documentos:\\n - Nota de Crédito sobre a fatura corrente no valor de <old_invoice_value>€;";
//
var _documentsToBeCreated_receipt =
  "Será cancelado(a) <invoice_type> nº <old_invoice_nr> e serão criados os seguintes documentos:\\n - Nota de Crédito sobre a fatura corrente no valor de <old_invoice_value>€;\\n - Fatura-Recibo com o montante remanescente, no valor de <new_invoice_value>€;";
//
const infoProcesso =
  "Este processo irá anular a fatura/recibo corrente, emitir uma nota de crédito no mesmo valor e emitir uma nova fatura/recibo com o valor remanescente";
//
const cancel_reason =
  "Anulação necessária de forma a permitir a correcção do valor pago através da emissão de nota de crédito.";

const validationSchema = object().shape({});
const styles = (theme) => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class NewCreditNote extends React.Component {
  state = {
    showAlert0: true,
    showAlert1: false,
    observations: "",
    formValues: {
      establishment_name: null,
      old_invoice_value: null,
      warranty_days: null,
      warranty_value_per_day: null,
      total_days: null,
      new_invoice_value: null,
      credit_value: null,
      elderly_name: null,
      monthly_payment: null,
      admission_date: null,
      requester_name: null,
      entity_user_name: null,
    },
  };
  warrantyDays = 90;
  totalDays = 30;
  observations = "";
  observationsAux = "";
  documentsToBeCreated = "";
  hasFiles = false;

  constructor() {
    super();
    this.api = new Api();
    this.setFinalValue = this.setFinalValue.bind(this);
    this.setObservations = this.setObservations.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.submissionConfirm = this.submissionConfirm.bind(this);
  }

  /**
   *
   */

  componentDidUpdate() {}

  /**
   *
   */

  setFinalValue(event, values) {
    const newInvoiceValue = (
      values.total_days *
      (values.invoice_value / values.warranty)
    ).toFixed(2);
    const credit_value = (values.invoice_value - newInvoiceValue).toFixed(2);
    //
    values.final_value = newInvoiceValue;
    //
    //set observations text model
    if (this.props.status === "settled" && values.total_days > 0)
      this.observationsAux = invoice_settled_observations;
    if (this.props.status === "settled" && values.total_days === 0)
      this.observationsAux = invoice_settled_observations_zero_days;
    if (this.props.status === "final" && values.total_days > 0)
      this.observationsAux = invoice_final_observations;
    if (this.props.status === "final" && values.total_days === 0)
      this.observationsAux = invoice_final_observations_zero_days;
    //
    this.setObservations("total_days", values.total_days, values);
    this.setObservations("new_invoice_value", newInvoiceValue, values);
    this.setObservations("credit_value", credit_value, values);
    //
    this.setFinalConfirmModal();
  }

  setObservations(field, value, values) {
    if (value === undefined || value === null) return;
    //
    var formValues = this.state.formValues;
    formValues[field] = value;
    this.state.formValues = formValues;
    //
    this.observations = this.observationsAux;
    if (this.state.formValues.establishment_name)
      this.observations = this.observations.replace(
        /<establishment_name>/g,
        this.state.formValues.establishment_name
      );
    if (this.state.formValues.old_invoice_value)
      this.observations = this.observations.replace(
        /<old_invoice_value>/g,
        this.state.formValues.old_invoice_value
      );
    if (this.state.formValues.warranty_days)
      this.observations = this.observations.replace(
        /<warranty_days>/g,
        this.state.formValues.warranty_days
      );
    if (this.state.formValues.warranty_value_per_day)
      this.observations = this.observations.replace(
        /<warranty_value_per_day>/g,
        parseFloat(this.state.formValues.warranty_value_per_day).toFixed(2)
      );
    if (this.state.formValues.total_days)
      this.observations = this.observations.replace(
        /<total_days>/g,
        this.state.formValues.total_days
      );
    if (this.state.formValues.new_invoice_value)
      this.observations = this.observations.replace(
        /<new_invoice_value>/g,
        parseFloat(this.state.formValues.new_invoice_value).toFixed(2)
      );
    if (this.state.formValues.credit_value)
      this.observations = this.observations.replace(
        /<credit_value>/g,
        parseFloat(this.state.formValues.credit_value).toFixed(2)
      );
    if (this.state.formValues.elderly_name)
      this.observations = this.observations.replace(
        /<elderly_name>/g,
        this.state.formValues.elderly_name
      );
    if (this.state.formValues.monthly_payment)
      this.observations = this.observations.replace(
        /<monthly_payment>/g,
        this.state.formValues.monthly_payment
      );
    if (this.state.formValues.admission_date)
      this.observations = this.observations.replace(
        /<admission_date>/g,
        this.state.formValues.admission_date
      );
    if (this.state.formValues.requester_name)
      this.observations = this.observations.replace(
        /<requester_name>/g,
        this.state.formValues.requester_name
      );
    //if(this.state.formValues.entity_user_name) this.observations = this.observations.replace(/<entity_user_name>/g,this.state.formValues.entity_user_name);
    //
    if (values) values.observations = this.observations;
  }

  setFinalConfirmModal() {
    var documentsToBeCreated_I = _documentsToBeCreated_invoice;
    var documentsToBeCreated_R = _documentsToBeCreated_receipt;
    var documentsToBeCreated_IZ = _documentsToBeCreated_invoice_zero;

    documentsToBeCreated_I = documentsToBeCreated_I.replace(
      /<new_invoice_value>/g,
      this.state.formValues.new_invoice_value
    );
    documentsToBeCreated_R = documentsToBeCreated_R.replace(
      /<new_invoice_value>/g,
      this.state.formValues.new_invoice_value
    );

    documentsToBeCreated_I = documentsToBeCreated_I.replace(
      /<old_invoice_value>/g,
      this.props.total
    );
    documentsToBeCreated_IZ = documentsToBeCreated_IZ.replace(
      /<old_invoice_value>/g,
      this.props.total
    );
    documentsToBeCreated_R = documentsToBeCreated_R.replace(
      /<old_invoice_value>/g,
      this.props.total
    );

    documentsToBeCreated_I = documentsToBeCreated_I.replace(
      /<old_invoice_nr>/g,
      this.props.sequence_number
    );
    documentsToBeCreated_IZ = documentsToBeCreated_IZ.replace(
      /<old_invoice_nr>/g,
      this.props.sequence_number
    );
    documentsToBeCreated_R = documentsToBeCreated_R.replace(
      /<old_invoice_nr>/g,
      this.props.sequence_number
    );

    var invoice_type_text =
      this.props.status === "final" ? " o recibo da Fatura" : "a Fatura-Recibo";
    documentsToBeCreated_I = documentsToBeCreated_I.replace(
      /<invoice_type>/g,
      invoice_type_text
    );
    documentsToBeCreated_IZ = documentsToBeCreated_IZ.replace(
      /<invoice_type>/g,
      invoice_type_text
    );
    documentsToBeCreated_R = documentsToBeCreated_R.replace(
      /<invoice_type>/g,
      invoice_type_text
    );

    this.documentsToBeCreated =
      this.props.status === "settled"
        ? documentsToBeCreated_R
        : this.state.formValues.new_invoice_value > 0
        ? documentsToBeCreated_I
        : documentsToBeCreated_IZ;
  }

  handleFile(e, values) {
    this.hasFiles = true;
    //
    values.observations = this.observations;
    //
    var file = e.target.files[0];
    values.attach_name = file.name;
    this.getBase64(file, (res) => {
      values.attach = res;
    });
  }

  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  closeAlert0 = () => {
    this.setState({ showAlert0: false });
  };

  closeAlert1 = () => {
    this.setState({ showAlert1: false });
  };

  submissionConfirm(handleSubmit) {
    handleSubmit();
    this.closeAlert1();
  }

  /**
   *
   */

  render() {
    const { request, classes, client, entity } = this.props;
    return request && client && client.id && entity && entity.id ? (
      this.renderForm()
    ) : (
      <div>
        <CircularProgress className={classes.progress} color="primary" />
      </div>
    );
  }

  renderForm() {
    //set observations text model
    if (this.props.status === "settled")
      this.observationsAux = invoice_settled_observations;
    if (this.props.status === "final")
      this.observationsAux = invoice_final_observations;
    //
    this.setObservations(
      "establishment_name",
      this.props.request.establishment_name
    );
    this.setObservations("warranty_days", this.warrantyDays);
    this.setObservations(
      "warranty_value_per_day",
      (this.props.total / this.warrantyDays).toFixed(2)
    );
    this.setObservations("old_invoice_value", this.props.total);
    this.setObservations("elderly_name", this.props.request.elderly_name);
    this.setObservations("admission_date", this.props.request.request_admitted);
    this.setObservations("monthly_payment", this.props.request.monthly_payment);
    this.setObservations("requester_name", this.props.request.requester_name);
    this.setObservations("entity_user_name", this.props.client.name);
    //
    const newInvoiceValue = this.state.formValues.new_invoice_value
      ? this.state.formValues.new_invoice_value
      : this.totalDays * (this.props.total / this.warrantyDays);
    let credit_value = (this.props.total - newInvoiceValue).toFixed(2);
    this.setObservations("total_days", this.totalDays);
    this.setObservations("new_invoice_value", newInvoiceValue);
    this.setObservations("credit_value", credit_value);
    //
    this.setFinalConfirmModal();

    const { getForm, onSubmit, request, client, total, status, type } =
      this.props;

    return (
      <>
        <Paper square>
          <Formik
            ref={(node) => getForm && getForm(node)}
            initialValues={{
              establishment_name: request.establishment_name,
              entity_name: client.name,
              payment_at: moment(moment.now()).add(15, "days"),
              invoice_value: total,
              warranty: this.warrantyDays,
              total_days: this.totalDays,
              final_value: (
                this.totalDays *
                (total / this.warrantyDays)
              ).toFixed(2),
              cancel_reason: cancel_reason,
              invoice_status: status,
              invoice_type: type,
              observations: this.observations,
              elderly_name: this.props.request.elderly_name,
            }}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={false}
            render={({ values, handleSubmit, setFieldValue, isSubmitting }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Grid container style={{ width: "95%", margin: "auto" }}>
                    <Grid item md={4} style={{ marginRight: "50px" }}>
                      <Typography variant="h6" color="primary" gutterBottom>
                        Dados do Cliente
                      </Typography>
                      <Field
                        name="entity_name"
                        label="Entidade"
                        variant="outlined"
                        margin="normal"
                        type="text"
                        component={TextField}
                        onChange={setFieldValue}
                        value={"" + values.entity_name}
                        disabled
                        fullWidth
                      />
                    </Grid>

                    <Grid item md={3} style={{ marginRight: "50px" }}>
                      <Typography variant="h6" color="primary" gutterBottom>
                        Dados da nova fatura
                      </Typography>

                      <Field
                        name="payment_at"
                        label="Data de Cobrança"
                        variant="outlined"
                        margin="normal"
                        component={DatePicker}
                        onChange={setFieldValue}
                        value={"" + values.payment_at}
                        hidden={status === "settled"}
                        fullWidth
                      />
                      <Field
                        name="final_value"
                        label="Montante final (€)"
                        type="number"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        onChange={setFieldValue}
                        value={values.final_value}
                        defaultValue={
                          (values.invoice_value / values.warranty) *
                          values.real_days
                        }
                        fullWidth
                        disabled
                      />
                    </Grid>

                    <Grid item md={3}>
                      <Typography variant="h6" color="primary" gutterBottom>
                        Dados para estorno
                      </Typography>

                      <Field
                        name="invoice_value"
                        label="Valor inicial (€)"
                        type="number"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        onChange={setFieldValue}
                        value={"" + values.invoice_value}
                        disabled
                        fullWidth
                      />
                      <Field
                        name="total_days"
                        label="Nº dias de estadia"
                        type="number"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        onChange={setFieldValue}
                        onKeyUp={(e) => this.setFinalValue(e, values)}
                        value={values.total_days}
                        fullWidth
                      />
                      <Typography
                        variant="caption"
                        color="primary"
                        gutterBottom
                      >
                        (Garantia: {values.warranty} dias)
                      </Typography>
                    </Grid>

                    <Grid item md={10} style={{ marginTop: "40px" }}>
                      <Typography
                        variant="h6"
                        color="primary"
                        gutterBottom
                        hidden={this.props.status.toLowerCase() === "settled"}
                      >
                        Motivo de cancelamento
                      </Typography>
                      <Field
                        name="cancel_reason"
                        label="Motivo cancelamento"
                        type="text"
                        variant="outlined"
                        margin="normal"
                        component={TextField}
                        onChange={setFieldValue}
                        value={values.cancel_reason}
                        fullWidth
                        hidden={this.props.status.toLowerCase() === "settled"}
                      />

                      <Field
                        name="observations"
                        label="Observações"
                        variant="outlined"
                        margin="normal"
                        type="text"
                        component={TextField}
                        multiline
                        rows={30}
                        fullWidth
                        onChange={setFieldValue}
                        value={"" + values.observations}
                        disabled={!values.send_email}
                        hidden={true}
                      />
                    </Grid>
                  </Grid>

                  <Paper style={{ textAlign: "right", marginTop: "40px" }}>
                    <Button
                      onClick={(e) => {
                        this.setFinalValue(e, values);
                        this.setState({ showAlert1: true });
                      }}
                      color="primary"
                      style={{ marginRight: "20px", fontSize: "medium" }}
                    >
                      Enviar para validação
                    </Button>
                  </Paper>

                  <ConfirmDialog
                    open={this.state.showAlert1}
                    title={"Atenção"}
                    message={this.documentsToBeCreated}
                    handleOk={() => this.submissionConfirm(handleSubmit)}
                    handleCancel={this.closeAlert1}
                  ></ConfirmDialog>
                </Form>
              );
            }}
          />
        </Paper>

        <AlertDialog
          open={this.state.showAlert0}
          handleClose={this.closeAlert0}
          title={"Atenção"}
          message={infoProcesso}
        ></AlertDialog>
      </>
    );
  }
}

NewCreditNote.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewCreditNote);
